import { ConfirmDialogComponent } from '@/components/confirm-dialog/confirm-dialog.component';
import { IntroDialogComponent } from '@/components/intro-dialog/intro-dialog.component';
import { AlertService } from '@/services/alert.service';
import { NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AdminService, UserRole } from '@eemo/api-client';

export type IntroUserType =
  | 'INDIVIDUAL'
  | 'INDIVIDUAL_WITH_SHARE'
  | 'PROFESSIONAL'
  | 'NOTARY'
  | 'REAL_ESTATE'
  | 'REAL_ESTATE_KW';

@Component({
  selector: 'app-admin-tools',
  templateUrl: './admin-tools.component.html',
  styleUrls: ['./admin-tools.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    NgFor,
    MatButtonModule,
    MatSelectModule
  ]
})
export class AdminToolsComponent {
  demoUid = new UntypedFormControl('', [Validators.required]);
  exportUid = new UntypedFormControl('', [Validators.required]);

  fileToImport: File;

  introUsers: IntroUserType[] = [
    'INDIVIDUAL',
    'INDIVIDUAL_WITH_SHARE',
    'PROFESSIONAL',
    'NOTARY',
    'REAL_ESTATE',
    'REAL_ESTATE_KW'
  ];
  introUser: IntroUserType = 'INDIVIDUAL';

  exportUserRoles = [UserRole.REAL_ESTATE, UserRole.INDIVIDUAL, UserRole.NOTARY, UserRole.PROFESSIONAL];
  exportUserRole = null;

  constructor(private adminService: AdminService, private dialog: MatDialog, private alertService: AlertService) {}

  confirmAddDemoProperty() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        // width: '25rem',
        data: {
          message: "Confirmez-vous l'ajout de ce bien en mode démo ?"
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.addDemoProperty();
        }
      });
    }
  }

  addDemoProperty() {
    if (this.demoUid.value) {
      this.adminService.addDemoProperty(this.demoUid.value).subscribe(() => {
        this.alertService.success('Bien de démo ajouté');
        this.demoUid.reset();
      });
    }
  }

  confirmRemoveDemoProperty() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        // width: '25rem',
        data: {
          message: 'Confirmez-vous la suppression de ce bien du mode démo ?'
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.removeDemoProperty();
        }
      });
    }
  }

  removeDemoProperty() {
    if (this.demoUid.value) {
      this.adminService.removeDemoProperty(this.demoUid.value).subscribe(() => {
        this.alertService.success('Bien de démo supprimé');
        this.demoUid.reset();
      });
    }
  }

  confirmExportProperty() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        // width: '25rem',
        data: {
          message: "Confirmez-vous l'export de ce bien ?"
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.exportProperty();
        }
      });
    }
  }

  exportProperty() {
    if (this.exportUid.value) {
      /*this.adminService.exportProperty(this.exportUid.value).subscribe(result => {
        this.alertService.success('Export effectué');
        this.exportUid.setValue(' ');
        window.open(window.URL.createObjectURL(result));
        fileSaver.saveAs(blob, 'employees.json');
      });
      */
      window.open(this.adminService.configuration.basePath + '/admin/properties/export/' + this.exportUid.value);
    }
  }

  confirmExportUser() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        // width: '25rem',
        data: {
          message: "Confirmez-vous l'export des utilisateurs ?"
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.exportUser();
        }
      });
    }
  }

  exportUser() {
    /*this.adminService.exportProperty(this.exportUid.value).subscribe(result => {
        this.alertService.success('Export effectué');
        this.exportUid.setValue(' ');
        window.open(window.URL.createObjectURL(result));
        fileSaver.saveAs(blob, 'employees.json');
      });
      */
    let url = this.adminService.configuration.basePath + '/admin/users/export';
    if (this.exportUserRole) {
      url += `?roles=${this.exportUserRole}`;
    }
    window.open(url);
  }

  importFileSelected(event: FileList) {
    if (event.length > 0) {
      this.fileToImport = event.item(0);
    } else {
      this.fileToImport = null;
    }
  }

  confirmImportProperty() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        // width: '25rem',
        data: {
          message: "Confirmez-vous l'import d'un nouveau bien depuis cette archive ?"
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.importProperty();
        }
      });
    }
  }

  importProperty() {
    if (this.fileToImport) {
      this.adminService.importProperty(this.fileToImport).subscribe(() => {
        this.alertService.success('Import effectué');
      });
    }
  }

  confirmSyncRights() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        // width: '25rem',
        data: {
          message: 'Confirmez-vous le lancement de la synchronisation des droits ?'
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.syncRights();
        }
      });
    }
  }

  syncRights() {
    this.adminService.synchronizeRights().subscribe(() => {
      this.alertService.success('Synchronisation lancée');
    });
  }

  showIntroUser() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      this.dialog.open(IntroDialogComponent, {
        data: {
          forceIndividual: this.introUser === 'INDIVIDUAL',
          forceIndividualWithShare: this.introUser === 'INDIVIDUAL_WITH_SHARE',
          forceProfessional: this.introUser === 'PROFESSIONAL',
          forceNotary: this.introUser === 'NOTARY',
          forceRealEstate: this.introUser === 'REAL_ESTATE',
          forceRealEstateKw: this.introUser === 'REAL_ESTATE_KW'
        }
      });
    }
  }
}
